import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any, storedVoiceBoxInfo: string) => {
  const respData = data?.data
  const jsonStoredVoiceBoxInfo = storedVoiceBoxInfo?.length > 0 ? JSON.parse(storedVoiceBoxInfo) : {}
  return respData.map((item: any) => {
    return {
      id: item.deviceid,
      title: item.deviceType,
      voiceAlertsEnabled: jsonStoredVoiceBoxInfo?.[item.deviceid]?.isVoiceAlertEnabled ?? true,
      invoices: [],
      details: {
        id: item.deviceid,
        tid: item.tid,
        dsn: item.deviceid,
        vpa: item.vpa,
        activatedOn: item.createdAt,
        fee: item?.oneTimeSetUpFee ?? 'NA',
        onTimeSetUpFee: item?.oneTimeSetUpFee ?? 'NA',
        monthlyCharges: item?.monthlyCharges ?? 'NA',
      },
      language: jsonStoredVoiceBoxInfo?.[item.deviceid]?.language ?? 'English',
    }
  })
}

const getAllVoiceBoxes = (tokens: any, req: any, storedVoiceBoxInfo: string) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: `${APIEndPoints.voiceboxes}`,
    method: 'POST',
    cache: false,
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data, storedVoiceBoxInfo)
  })
}

export { getAllVoiceBoxes }
